export default "__VITE_ASSET__ce8fa535__"